export function extractArray<T>(payload: unknown): T[] {
  if (Array.isArray(payload)) return payload as T[]
  if (typeof payload === 'object' && payload !== null) {
    const obj = payload as Record<string, unknown>
    if (Array.isArray(obj.data)) return obj.data as T[]
    if (typeof obj.data === 'object' && obj.data !== null) {
      const inner = obj.data as Record<string, unknown>
      if (Array.isArray(inner.data)) return inner.data as T[]
    }
    if (Array.isArray(obj.items)) return obj.items as T[]
  }
  return []
}

export function extractItem<T>(payload: unknown): T | null {
  if (typeof payload === 'object' && payload !== null) {
    const data = (payload as { data?: unknown }).data
    if (data !== undefined) return data as T
    return payload as T
  }
  return null
}

export function extractMeta(payload: unknown): { total: number; totalPages: number } {
  if (typeof payload === 'object' && payload !== null) {
    const meta = (payload as { meta?: { total?: number; totalPages?: number } }).meta
    return {
      total: meta?.total ?? 0,
      totalPages: meta?.totalPages ?? 1,
    }
  }
  return { total: 0, totalPages: 1 }
}
